<template>
  <component :is="element.is" v-bind="element.props">
    <template
      v-for="[name, html] in Object.entries(element.slots)"
      #[name]
      :key="name"
    >
      <div v-html="html"></div>
    </template>
  </component>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IStepElement } from "../model/flow.types"

  export default defineComponent({
    props: {
      element: {
        type: Object as PropType<IStepElement>,
        required: true,
      },
    },
  })
</script>
